import { Menu, MenuProps } from "antd";
import { Link, useLocation } from "react-router-dom";
import {
  BlockOutlined,
  DashboardOutlined,
  CalculatorOutlined,
  FundOutlined,
  PercentageOutlined,
} from "@ant-design/icons";
import { useMenuOpenKeys } from "../../../hooks/global/useOpenMenuKeys";

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group',
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

const items: MenuItem[] = [
  getItem("Main menu", "main-menu-group", null, [
    getItem(<Link to="/dashboard">Dashboard</Link>, "/dashboard", <DashboardOutlined />),
    // getItem(<Link to="/platforms">Platforms</Link>, "/platforms", <BlockOutlined />),
    getItem(<Link to="/providers">Providers</Link>, "/providers", <BlockOutlined />),
    getItem(<Link to="/fmv">FMV</Link>, "/fmv", <CalculatorOutlined />),
    // Calculator is still under development — shown but not navigable from the menu.
    {
      ...getItem("Calculator (SOON)", "/calculator", <FundOutlined />),
      disabled: true,
      title: "Calculator is under development",
    } as MenuItem,
  ], 'group'),
  getItem("Settings", "settings-group", null, [
    getItem(<Link to="/tfs-srp-year-rates">TFS SRP Year Rates</Link>, "/tfs-srp-year-rates", <PercentageOutlined />),
  ], 'group'),
];

export const SiderNavigationComponent = () => {
  const { openKeys, onOpenChange } = useMenuOpenKeys();
  const location = useLocation();

  return (
    <Menu
      className="app-menu"
      mode="inline"
      theme="light"
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      selectedKeys={[location.pathname]}
      items={items}
    />
  );
};
